import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from '@/contexts/AuthContext';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App />
      <Toaster
        position="bottom-right"
        gutter={8}
        containerStyle={{
          bottom: 24,
          right: 24,
          zIndex: 99999,
        }}
        toastOptions={{
          duration: 2500,
          style: {
            background: 'rgba(15, 23, 42, 0.95)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            color: '#f8fafc',
            borderRadius: '12px',
            fontSize: '13px',
            fontWeight: 500,
            padding: '10px 16px',
            border: '1px solid rgba(255, 255, 255, 0.12)',
            boxShadow: '0 12px 28px -4px rgba(0, 0, 0, 0.4), 0 4px 12px -2px rgba(0, 0, 0, 0.2)',
            fontFamily: 'Inter, sans-serif',
            maxWidth: '360px',
          },
          success: {
            style: {
              borderLeft: '4px solid #10b981',
            },
            iconTheme: {
              primary: '#10b981',
              secondary: '#0f172a',
            },
          },
          error: {
            duration: 3500,
            style: {
              borderLeft: '4px solid #ef4444',
            },
            iconTheme: {
              primary: '#ef4444',
              secondary: '#0f172a',
            },
          },
          loading: {
            style: {
              borderLeft: '4px solid #6366f1',
            },
            iconTheme: {
              primary: '#6366f1',
              secondary: '#0f172a',
            },
          },
        }}
      />
    </AuthProvider>
  </StrictMode>,
);
